import {
  quizById,
  QuizByIdRequestParams,
} from "@/requests/questionnaries/quiz-by-id.request";
import { useQuery } from "@tanstack/react-query";

export const buildQuizByIdQueryKey = (params: QuizByIdRequestParams) => {
  return [
    "companies",
    params.companyId,
    "quiz", // wrong choice for the key, should be quizzes but it's already written
    params.applicationQuizId,
    "details",
  ];
};

export const useQuizById = (params: QuizByIdRequestParams) => {
  return useQuery({
    queryKey: buildQuizByIdQueryKey(params),
    queryFn: () => quizById(params),
    enabled: Boolean(params.applicationQuizId) && Boolean(params.companyId),
  });
};
